var map = {
	"./ad01.jpg": 8264,
	"./aftersale_notice.jpg": 5387,
	"./alipay.png": 6981,
	"./allinpay.png": 8290,
	"./avatar.png": 8987,
	"./clips_bg.png": 3967,
	"./clips_bg_yuan.png": 9180,
	"./coupon_right.jpg": 3425,
	"./folder_image_0.jpg": 2650,
	"./folder_image_2.png": 326,
	"./generating_thumb.jpg": 9451,
	"./index_slider_01.jpg": 9028,
	"./login.png": 5567,
	"./login_bg.jpg": 7233,
	"./logo.jpg": 9218,
	"./logo.png": 4427,
	"./money_pay.jpg": 7484,
	"./user_profile_exp.jpg": 5327,
	"./user_rights.jpg": 2686,
	"./wechat_qr.jpg": 8732,
	"./wechatpay.jpg": 5966,
	"./wechatpay_exp.jpg": 8903,
	"./wechatpay_focus_ico.jpg": 5913
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;